import DefaultIcon from "./assets/icons/No-Image-Placeholder.svg.png";

export const DEFAULT_IMG = DefaultIcon;
